import { Badge, BadgeStatus } from '../types/fingeringEditor';

/**
 * 和音（chord）全体の代表ステータスを決定する。
 *
 * 優先順位: added > edited > auto
 * - 一つでも `added` があれば全体を `added` とみなす（新規追加の痕跡を残す）
 * - `added` がなく `edited` があれば `edited`
 * - すべて `auto` なら `auto`
 *
 * 背景色を chord 内の特定 note（インデックス0など）だけで決めると、
 * ノート追加・修正・並び替えで色がちぐはぐになるため、chord 全体で統一する。
 *
 * @param chordNotes 和音を構成する badge 配列
 * @returns 代表 BadgeStatus
 */
export function chordStatus(chordNotes: Badge[]): BadgeStatus {
  if (chordNotes.length === 0) return 'auto';
  if (chordNotes.some((n) => n.status === 'added')) return 'added';
  if (chordNotes.some((n) => n.status === 'edited')) return 'edited';
  return 'auto';
}
